import { createContext, useContext } from 'react';

interface HeaderFooterBackdropContextModel {
  visible: boolean;
  setVisible: (visible: boolean) => void;
}

export const HeaderFooterBackdropContext = createContext<HeaderFooterBackdropContextModel | undefined>(undefined);

export const useHeaderFooterBackdrop = () => {
  const context = useContext(HeaderFooterBackdropContext);

  if (!context) {
    throw new Error(`useCoreContext must be used within a CoreContextProvider`);
  }

  return context;
};
